import { GzWidgetSectionWithIconsAndPercentageItemWebComponent } from './component/GzWidgetSectionWithIconsAndPercentageItemWebComponent';

export { GzWidgetSectionWithIconsAndPercentageItemWebComponent };
